<template>
  <div class="page">
    <wk-search class="wrapBox" :search-control-data="searchControlData" @search="search($event)"></wk-search>
    <black-export
        class="wrapBox"
        v-auth="permission.BLACK_ACTION_EXPORT"
        @export="exportClick($event)">
    </black-export>
    <div class="wrapBox">
      <div class="flex justify-space-between" style="margin-bottom: 10px">
        <div class="line-40">共{{ total }}条数据</div>
        <el-button v-auth="permission.BLACK_ACTION_ADD" class="common-button" type="primary" @click="handleModify">
          添加黑名单
        </el-button>
      </div>
      <el-table
          class="tableBox W100"
          :data="tableData"
          stripe
          v-auth="permission.BLACK_ACTION_LIST"
      >
        <el-table-column fixed align="center" width="60" type="index" label="序号"></el-table-column>
        <el-table-column fixed prop="apkName" label="应用名称"></el-table-column>
        <el-table-column prop="apkPackage" label="应用包名"></el-table-column>
        <el-table-column prop="createTime" label="添加时间">
          <template slot-scope="scope">
            <span>{{ scope.row.createTime | parseTime() }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="accountId" label="开发者ID"></el-table-column>
        <el-table-column prop="companyName" label="企业名称">
          <template slot-scope="scope">
            <span v-if="scope.row.companyName">{{ scope.row.companyName }}</span>
            <span v-else>{{ scope.row.contactName }}</span>
          </template>
        </el-table-column>
        <el-table-column
            align="center"
            label="操作"
            width="120"
        >
          <template slot-scope="scope">
            <el-button
                v-auth="permission.BLACK_ACTION_DELETE"
                class="color-blue link-button"
                type="text" @click="handleDelete(scope.row)"
            >删除
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class="text-right margin-t30">
        <el-pagination
            background
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :page-sizes="[10, 20, 50, 100]"
            :page-size="searchFormData.perPage"
            :current-page="searchFormData.page"
            layout="total, prev, pager, next, sizes"
            :total="total"
        ></el-pagination>
      </div>
    </div>
    <modifyDialog ref="dialog" @refresh="search()"></modifyDialog>
  </div>
</template>
<script>
import modifyDialog from "./components/modifyDialog";
import BlackExport from './components/blackExport';
import store from '@/store/index.js';

export default {
  beforeRouteEnter: (to, from, next) => {
    store.commit("breadcrumbStore/setMenuBreadcrumb", {
      'menu': to.meta.menuBreadcrumb,
      name: "黑名单管理",
      path: to.fullPath
    });
    next()
  },
  components: {modifyDialog, BlackExport},
  data() {
    return {
      type: "1",//判断是应用还是版本
      //搜索form组件
      searchControlData: [
        {
          type: "input",
          label: "应用名称",
          placeholder: "应用名称",
          key: "apkName"
        },
        {
          type: "input",
          label: "应用包名",
          placeholder: "应用包名",
          key: "apkPackage"
        },
        {
          type: "input",
          label: "开发者ID",
          placeholder: "开发者ID",
          key: "accountId"
        },
      ],
      //列表数据
      tableData: [],
      total: 0,
      //搜索form数据
      searchFormData: {
        page: 1,
        perPage: 10
      },
    };
  },

  created() {
    this.search();
  },
  methods: {
    //搜索方法
    search(data) {
      if (data) {
        this.searchFormData = {
          page: 1,
          perPage: this.searchFormData.perPage,
          ...data
        };
      }
      this.$apis.blackServer.queryList(this.searchFormData).then(res => {
        if (res['code'] == 0 && res.data.data) {
          this.total = res.data.total;
          this.tableData = res.data.data;
        } else {
          this.total = 0;
          this.tableData = [];
        }
      });
    },
    //导出方法
    exportClick(data) {
      console.log(data);
      //时间范围组件 取开始结束时间
      data.startTime = data.time ? data.time[0] : "";
      data.endTime = data.time ? data.time[1] : "";
      this.$apis.blackServer.exportBlacklist(data).then(res => {
        if (res['code'] == 0 && res.data.link) {
          let link = res.data.link;
          window.location.href = link;
        } else {
          this.$message({
            message: "失败",
            type: "error"
          });
        }
      });
    },
    //点击编辑
    handleModify() {
      console.log(this.$refs["dialog"]);
      this.$refs["dialog"].showDialog();
    },
    // 删除
    handleDelete(data) {
      this.$confirm(`确定从黑名单中删除${data.apkPackage}吗？`, '删除提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        cancelButtonClass: 'cancelButton',
        confirmButtonClass: 'confirmButton',
        type: 'info ',
        center: true
      }).then(() => {
        this.$apis.blackServer.deleteBlack({
          id: data.id
        }).then(res => {
          if (res['code'] == 0) {
            this.search()
            this.$message({
              type: 'success',
              message: '删除成功!'
            });
          }
        })
      })
    },
    //table点击更改一页多少行
    handleSizeChange(val) {
      this.searchFormData.perPage = val;
      this.search();
    },
    //table点击修改页码
    handleCurrentChange(val) {
      this.searchFormData.page = val;
      this.search();
    },
  }
};
</script>
<style scoped lang="scss">
/deep/ .el-message-box--center .el-message-box__message {
  font-size: 20px;
}
</style>
